import Flow from "src/components/Flow";
import MyAccount from "src/scenes/MyAccount";
import SignUp from "src/modules/auth/scenes/SignUp";
import Login from "src/modules/auth/scenes/Login";
import ManageSubscription from "src/modules/purchase/scenes/ManageSubscription";
import PurchaseFlow from "src/modules/purchase/PurchaseFlow";

const steps = [
  {
    id: "my-account",
    Component: (props) => <MyAccount {...props} />
  },
  {
    id: "sign-up",
    Component: ({ flow, onClose }) => (
      <SignUp
        onClose={onClose}
        onBack={() => flow.previous()}
        onSuccess={() => flow.previous()}
        showAlreadyHaveAccount={false}
      />
    )
  },
  {
    id: "login",
    Component: ({ flow, onClose }) => (
      <Login
        mode="modal"
        onClose={onClose}
        onBack={() => flow.previous()}
        onSuccess={() => flow.previous()}
      />
    )
  },
  {
    id: "manage-subscription",
    Component: ({ flow, onClose }) => (
      <ManageSubscription onBack={flow.previous} onClose={onClose} />
    )
  },
  {
    id: "purchase",
    Component: ({ flow, onClose }) => (
      <PurchaseFlow onBack={flow.previous} onClose={onClose} />
    )
  },
  {
    id: "restore",
    Component: ({ flow, onClose }) => (
      <PurchaseFlow
        onBack={flow.previous}
        initialStep="enter-token"
        onClose={onClose}
      />
    )
  }
];

export default function MyAccountFlow(props) {
  return <Flow steps={steps} {...props} />;
}
